module.exports = __webpack_public_path__ + "static/media/birdbrainSkinner.2aa44c05.jpg";